import { render } from "./editCollegestudent.vue?vue&type=template&id=1bb74288&scoped=true"
import script from "./editCollegestudent.vue?vue&type=script&lang=js"
export * from "./editCollegestudent.vue?vue&type=script&lang=js"

import "./editCollegestudent.vue?vue&type=style&index=0&id=1bb74288&scoped=true&lang=css"

import exportComponent from "/mnt/extra-storage/2026_cdf/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bb74288"]])

export default __exports__